/**
 * Τραπέζια-προορισμοί της «Μετακίνησης» του ταμείου (όλο το τραπέζι ή επιλεγμένα είδη).
 *
 * Από ΟΛΕΣ τις ζώνες του καταστήματος (11/10/2026): το παράθυρο έπαιρνε τα τραπέζια της οθόνης, δηλαδή μόνο
 * της ζώνης που ήταν ανοιχτή, και το GENERIS δεν μπορούσε να μεταφέρει τραπέζι από τη «ΣΑΛΑ 1» στο «ΠΙΣΩ».
 * Ο server δεν είχε ποτέ τέτοιο όριο (sessions/:id/move, order-items/:id/move: οποιοδήποτε τραπέζι του
 * καταστήματος).
 *
 * Ομάδες ανά ζώνη: πρώτα η τρέχουσα, μετά οι υπόλοιπες με τη σειρά που έρχονται (GET /tables: display_order).
 * Όλο το τραπέζι πάει μόνο σε ελεύθερο· τα είδη και σε κατειλημμένο (μπαίνουν στον λογαριασμό του).
 */
export interface MoveTargetTable {
  id: number;
  zone_id: number;
  table_number: string;
  name?: string | null;
  status: string;
  zone_name?: string | null;
}

export interface MoveTargetGroup<T extends MoveTargetTable> {
  zoneId: number;
  zoneName: string;
  tables: T[];
}

export function groupMoveTargets<T extends MoveTargetTable>(
  tables: T[],
  opts: { excludeTableId: number; currentZoneId: number | null | undefined; includeOccupied: boolean },
): MoveTargetGroup<T>[] {
  const groups = new Map<number, MoveTargetGroup<T>>();
  for (const table of tables) {
    if (table.id === opts.excludeTableId) continue;
    if (!(table.status === 'available' || (opts.includeOccupied && table.status === 'occupied'))) continue;
    let group = groups.get(table.zone_id);
    if (!group) {
      group = { zoneId: table.zone_id, zoneName: table.zone_name || '', tables: [] };
      groups.set(table.zone_id, group);
    }
    group.tables.push(table);
  }
  const list = Array.from(groups.values());
  const current = list.findIndex((g) => g.zoneId === opts.currentZoneId);
  if (current > 0) list.unshift(list.splice(current, 1)[0]);
  return list;
}
